export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Caret down</title>
    <path
      d="M3.5 11.5 16 24l12.5-12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
